import { selectMatchEvents } from 'features/match/matchSlice';
import { getConnectedAssistEvent } from 'helpers/getConnectedEvent';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { EventTextProps } from './EventText';

const EventTextOwnGoal: React.FC<EventTextProps> = ({ matchEvent }) => {
  const matchEvents = useSelector(selectMatchEvents);

  const team = matchEvent?.team?.name;
  const player = matchEvent?.person?.name;
  const { score } = matchEvent;

  const assistEvent = getConnectedAssistEvent(matchEvents, matchEvent);

  const justTeam = team && !player && !assistEvent;
  const teamAndGoalscorer = team && player && !assistEvent;

  if (score && score.length > 0) {
    if (teamAndGoalscorer) {
      return <FormattedMessage id="eventText.ownGoal.teamAndGoalscorer" values={{ team, score, player }} />;
    }

    if (justTeam) {
      return <FormattedMessage id="eventText.ownGoal.justTeam" values={{ team, score }} />;
    }
  } else {
    if (teamAndGoalscorer) {
      return <FormattedMessage id="eventText.noScore.ownGoal.teamAndGoalscorer" values={{ team, score, player }} />;
    }

    if (justTeam) {
      return <FormattedMessage id="eventText.noScore.ownGoal.justTeam" values={{ team, score }} />;
    }
  }

  const assistPlayerName = assistEvent?.person?.name;

  if (score && score.length > 0) {
    const messageValues = { team, score, player, assistPlayerName };
    if (!assistPlayerName) {
      return <FormattedMessage id="eventText.ownGoal" values={messageValues} />;
    } else {
      return <FormattedMessage id="eventText.ownGoalIndirect" values={messageValues} />;
    }
  } else {
    const messageValues = { team, player, assistPlayerName };
    if (!assistPlayerName) {
      return <FormattedMessage id="eventText.noScore.ownGoal" values={messageValues} />;
    } else {
      return <FormattedMessage id="eventText.noScore.ownGoalIndirect" values={messageValues} />;
    }
  }
};

export default EventTextOwnGoal;
